import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const pagesAdapter = createEntityAdapter();

const initialState = pagesAdapter.getInitialState({
	status: "idle",
	error: null,
});

const pagesSlice = createSlice({
	name: "pages",
	initialState,
	reducers: {
		pagesReceived(state, action) {
			pagesAdapter.setAll(state, action.payload);
		},
	},
});

/*
ACTIONS
pages data can only ever be received via API
There are no actions to CRUD individual pages
*/
export const { pagesReceived, pageDecremented } = pagesSlice.actions;

/*
SELECTORS
*/
export const { selectAll: selectAllPages, selectById: selectPageById } =
	pagesAdapter.getSelectors((state) => state.pages);

/*
CUSTOM SELECTORS
*/
export const selectPagesError = (state) => state.pages.error;

export default pagesSlice.reducer;
